module.exports = __webpack_public_path__ + "static/img/game2.a2e9e1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/game2.jpg
// module id = AEBr
// module chunks = 1